/*
 * @description:
 * @author: wolfgun
 * @Date: 2020-10-16 16:13:22
 */
export const pushStatusEnum = [
  { value: 0, label: '暂存' },
  { value: 1, label: '已发布' }
]

export const isRegisterEnum = [
  { value: 0, label: '否' },
  { value: 1, label: '是' }
]

export const showTypeEnum = [
  { value: 1, label: '无点击效果' },
  { value: 2, label: '点击跳转链接' },
  { value: 3, label: '点击跳转富文本' }
]

export const ROUTER_ANNOUNCE_ADD_OR_UPDATE = 'content/notice/add-or-update'
export const ROUTER_ANNOUNCE_LIST = 'content/notice/add-or-update'
export const ROUTER_ANNOUNCE_VIEW = 'content/notice/detail'

